export function parseHTML(text) {
  const el = window.document.createElement("div")
  el.innerHTML = text
  return {
    element: el,
    document
  }
}
